module.exports = __webpack_public_path__ + "img/1L2.44ea6622.png";